import React, { createContext, useState, useContext } from 'react';

const AuthContext = createContext(null);

// --- SIMULACIÓN DE BASE DE DATOS DE USUARIOS ---
const mockUsers = [
    {
        id: 'user-001',
        username: 'recepcion',
        password: '123',
        name: 'Ana López',
        clinicId: 'clinic-a',
        roles: ['recepcion']
    },
    {
        id: 'user-002',
        username: 'medico',
        password: '123',
        name: 'Dr. Alejandro Magno',
        clinicId: 'clinic-a',
        roles: ['medico']
    },
    {
        id: 'user-003',
        username: 'admin',
        password: '123',
        name: 'Gerardo M.',
        clinicId: 'clinic-b',
        roles: ['administracion', 'medico', 'imagenologia'] // Usuario con múltiples roles
    },
    {
        id: 'user-004',
        username: 'host',
        password: '123',
        name: 'Juan Anfitrión',
        clinicId: 'clinic-a',
        roles: ['host']
    }
];

// --- SIMULACIÓN DE BASE DE DATOS DE SITIOS/CLÍNICAS ---
const mockSites = [
    { id: 'clinic-a', name: 'Clínica Central' },
    { id: 'clinic-b', name: 'Consultorios del Sur' },
    { id: 'clinic-c', name: 'Hospital Metropolitano' },
];

export const AuthProvider = ({ children }) => {
    // En una app real, esto vendría de un token, cookie, etc.
    const [user, setUser] = useState(null); 

    const [pacsConfig, setPacsConfig] = useState({
        ip: '192.168.100.65',
        port: 11112,
        aeTitle: 'DCM4CHEE'
    });

    // Simula un inicio de sesión
    const login = (credentials) => {
        const foundUser = mockUsers.find(u => u.username === credentials.username && u.password === credentials.password);
        if (foundUser) {
            setUser(foundUser);
            return true; // Login exitoso
        }
        return false; // Login fallido
    };

    // Cierra la sesión
    const logout = () => {
        setUser(null);
    };

    const updatePacsConfig = (newConfig) => {
        setPacsConfig(newConfig);
        console.log("Configuración del PACS actualizada:", newConfig);
    };

    const value = { 
        user, 
        isAuthenticated: !!user, 
        login, 
        logout,
        sites: mockSites, // Hacemos la lista de sitios accesible en toda la app
        users: mockUsers, // Exponemos la lista de usuarios para el panel de admin
        pacsConfig,
        updatePacsConfig
    };

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
    return useContext(AuthContext);
};
